import styled, { css, CSSProperties } from 'styled-components';

import {
  overflowStyles,
  sizeStyles,
  spacingStyles,
  StyledOverflowProps,
  StyledSizeProps,
  StyledSpacingProps,
  StyledTextProps,
  textStyles,
} from '../../../../styles';
import { fontSizes, spacing } from '../../../../theme';
import { DataTableClassNames, DataTableVariableNames } from '../../constants';

export const cellTextStyles = css`
  font-size: ${fontSizes.xs};
  line-height: 16px;
  vertical-align: middle;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const clickableCellStyles = css`
  cursor: pointer;
  outline: none;

  &:focus {
    box-shadow: inset 0 0 0 var(${DataTableVariableNames.OutlineWidth})
      var(${DataTableVariableNames.OutlineColor});
  }
`;

type CellRootProps = StyledSpacingProps &
  StyledSizeProps &
  StyledOverflowProps &
  StyledTextProps & {
    $borderColor: 'focused' | CSSProperties['borderColor'];
    onClick?: React.MouseEventHandler<HTMLTableCellElement>;
    onDoubleClick?: React.MouseEventHandler<HTMLTableCellElement>;
  };

export const CellRoot = styled.td<CellRootProps>`
  position: relative;
  box-sizing: border-box;
  ${cellTextStyles}
  padding: ${spacing['8x']} ${spacing['12x']};

  ${({ $borderColor }) =>
    $borderColor
      ? `box-shadow: inset 0 0 0 var(${DataTableVariableNames.OutlineWidth}) ${
          $borderColor === 'focused'
            ? `var(${DataTableVariableNames.OutlineColor})`
            : $borderColor
        };`
      : ''}

  ${({ onClick, onDoubleClick }) =>
    !onClick && !onDoubleClick ? '' : clickableCellStyles}



  .${DataTableClassNames.CellAction} {
    opacity: 0;

    &:has(> [aria-expanded='true']) {
      opacity: 1;
    }
  }

  &:focus,
  &:focus-within,
  &:hover {
    .${DataTableClassNames.CellAction} {
      opacity: 1;
    }
  }

  ${spacingStyles}
  ${sizeStyles}
  ${overflowStyles}
  ${textStyles}
`;

export const CellAction = styled.div`
  position: absolute;
  top: calc(${spacing['8x']} / 2);
  right: calc(${spacing['8x']} / 2);
  box-sizing: border-box;
  width: auto;
  background-color: var(${DataTableVariableNames.BackgroundColor});
`;
